import React from 'react'
import {Navigate} from "react-router-dom";
import {useState} from "react";
import {Container} from 'react-bootstrap'
import Spinner from "react-bootstrap/Spinner";
import {ToastContainer, toast} from "react-toastify";
import axios from '../../utils/axios';
import BusinessCredentialModal from '../../modal/credentialsModal';
import BusinessRegister from "../../modal/businessRegisterModal";
import imageUrl from '../../utils/imageUrl';

function SignIn() {
    // const navigate = useNavigate();
    let [bName, setBName] = useState("");
    const [password, setPassword] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loader, setLoader] = useState(false);

    const handleLoader = (val) => {
        setLoader(val);
    };

    const handleSubmit = (event) => {
        if (bName === '') {
            toast('Name required!');
            event.preventDefault();
            return;
        } else if (password === '') {
            toast('Password required!')
            event.preventDefault();
            return;
        } else {
            bName = bName.trim();
        }
        event.preventDefault();
        console.log(bName, password);
        handleLoader(true);
        const json = {businessName: bName, Password: password};
        axios
            .post("business/loginBusiness", json)
            .then((response) => {
                console.log(response.data);
                if (response.data.Data) {
                    handleLoader(false);
                    toast("Login successful..");
                    window.sessionStorage.setItem("isLoggedIn", "true");
                    var bData = response.data.Data;
                    bData.Image = `${imageUrl}${bData.Image}`;
                    window.sessionStorage.setItem("business", JSON.stringify(bData));
                    setTimeout(() => setIsLoggedIn(true), 1000);
                } else {
                    handleLoader(false);
                    setPassword("");
                    setBName("");
                    toast(response.data.Message);
                }
            })
            .catch((err) => {
                console.log(err);
                var text = 'Something went wrong!';
                if (err.response.status === 404) {
                    text = 'Business not found!';
                }
                handleLoader(false);
                toast(text);
            });
    };
    // const navigateToContacts = () => {
    //     // 👇️ navigate to /contacts
    //     navigate('/contacts');
    //   };

    if (isLoggedIn) {
        return <Navigate to="/dashboard"/>;
    }
    return (
        <>
            <ToastContainer/>
            <section className='signin'>
                <form>
                    <img src='./images/background.jpg' className='bg'/>
                    <div className='overlay'>
                        <div className='container'>
                            <div className='row h-100vh align-items-center'>
                                <div className='col-md-4 mx-auto p-4'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <div className='heading text-center'>
                                                <h2 className='h4 mb-0'>Business Sign In</h2>
                                                <small>Enter your ID and Password</small>
                                            </div>
                                            <form className='form'>
                                                <div className='mb-3 mt-4'>
                                                    <input type='text' className='form-control'
                                                           placeholder='Enter Your UserName'
                                                           onChange={(event) => setBName(event.target.value)}/>
                                                </div>
                                                <div className='mb-4'>
                                                    <input type='password' className='form-control'
                                                           placeholder='Enter Your Password'
                                                           onChange={(event) => setPassword(event.target.value)}/>
                                                </div>
                                                <div className='mb-3 mt-3'>
                                                    <button type='submit' className='btn btn-primary w-100'
                                                            onClick={handleSubmit}>Sign in
                                                    </button>
                                                </div>

                                            </form>
                                            <BusinessRegister/>
                                            {loader ? (
                                                <div className="w-100 text-center">
                                                    <Spinner animation="border" role="status" variant='dark'>
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className='mb-4 mt-4 text-center' style={{color: 'black'}}>
                                                        <p>OR</p>
                                                    </div>
                                                    < BusinessCredentialModal/>
                                                </>
                                            )}
                                            <hr/>
                                            <div className='mb-4 mt-4' style={{color: 'black'}} align={'center'}>
                                                <p><b>Authorised Personnel Login</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </section>
        </>
    )
}

export default SignIn
